import styled from 'styled-components';
import LocationSvg from '../../assets/mytrips/location.svg';

const LocationIcon = styled(LocationSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default LocationIcon;
